/**
 * Created by lovely on 2016/6/7.
 */
'use strict';


var _ = require('underscore');
var appTypes = require('../types/appTypes');
var colorHelper = require('./colorHelper');
var util = require('./util');

var MAX_IMGSIZE = 8192;

var colorTemplete = [
  "FFED5555", "FFFC8D52", "FFFFCE55", "FFA0D468",
  "FF48CFAE", "FF5D9CEC",  "FFAC92ED", "FFEC87BF",
  "FFFFFFFF", "FFE6E6E6", "FFC0C0C0", "FFA0A0A0"
];

/**
 * 绘制圆角矩形
 * @param ctx
 * @param x
 * @param y
 * @param width
 * @param height
 * @param radius
 * @param fill
 * @param stroke
 */
function roundRect(ctx, x, y, width, height, radius, fill, stroke, borderVisible) {
  if (typeof stroke == 'undefined') {
    stroke = true;
  }
  if (typeof radius === 'undefined') {
    radius = 5;
  }
  if (typeof radius === 'number') {
    radius = {tl: radius, tr: radius, br: radius, bl: radius};
  } else {
    var defaultRadius = {tl: 0, tr: 0, br: 0, bl: 0};
    for (var side in defaultRadius) {
      radius[side] = radius[side] || defaultRadius[side];
    }
  }
  ctx.beginPath();

  if (!borderVisible.top) {
    radius.tl = 0;
    radius.tr = 0;
  }
  if (!borderVisible.right) {
    radius.tr = 0;
    radius.br = 0;
  }

  if (!borderVisible.bottom) {
    radius.br = 0;
    radius.bl = 0;
  }

  if (!borderVisible.left) {
    radius.bl = 0;
    radius.tl = 0;
  }

  if (stroke) {
    // top
    if (borderVisible.top) {
      ctx.moveTo(x + radius.tl, y);
      ctx.lineTo(x + width - radius.tr, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
    }

    // right
    if (borderVisible.right) {
      ctx.moveTo(x + width, y + radius.tr);
      ctx.lineTo(x + width, y + height - radius.br);
      ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
    }

    // bottom
    if (borderVisible.bottom) {
      ctx.moveTo(x + width - radius.br, y + height);
      ctx.lineTo(x + radius.bl, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
    }

    // left
    if (borderVisible.left) {
      ctx.moveTo(x, y + height - radius.bl);
      ctx.lineTo(x, y + radius.tl);
      ctx.quadraticCurveTo(x, y, x + radius.tl, y);
    }
    ctx.stroke();
  }

  if (fill) {
    ctx.beginPath();
    ctx.moveTo(x + radius.tl, y);
    ctx.lineTo(x + width - radius.tr, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
    ctx.lineTo(x + width, y + height - radius.br);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
    ctx.lineTo(x + radius.bl, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
    ctx.lineTo(x, y + radius.tl);
    ctx.quadraticCurveTo(x, y, x + radius.tl, y);
    ctx.closePath();
    ctx.fill();
  }
}

module.exports = {
  getImageSize: function (img, cb) {
    var newImg = document.createElement('img');
    newImg.src = img.src;
    newImg.style.position = 'absolute';
    newImg.style.left = '-9999px';
    newImg.style.top = '-9999px';
    document.body.appendChild(newImg);
    newImg.onload = function () {
      cb(null, {
        width: this.width || img.naturalWidth || newImg.width,
        height: this.height || img.naturalHeight || newImg.height
      }, newImg);
      document.body.removeChild(newImg);
    };
  },

  setDash: function (ctx, dashArr) {
    if (!dashArr) {
      dashArr = [];
    }
    if (ctx.setLineDash) {
      ctx.setLineDash(dashArr);
      ctx.lineDashOffset = 0;
    } else if (ctx.mozDash) {
      ctx.mozDash = dashArr;
      ctx.mozDashOffset = 5;
    }
  },

  initContextStyle: function (ctx, thickness, strokeColor, fillColor, lineMode) {
    var dashArr;
    var s;
    var langDadh;
    var dotDash;
    var ratio = this.getDeviceRatio(ctx);
    thickness = thickness || 1;
    s = Math.max(1, thickness / 2) * ratio;
    langDadh = 5 * s;
    dotDash = 1;
    if (thickness > 1) {
      dotDash = 0.1;
    }
    if (lineMode === 'dashed') {
      dashArr = [langDadh, langDadh];
    } else if (lineMode === 'dotted') {
      dashArr = [dotDash, langDadh];
    } else if (lineMode === 'dash-dot') {
      dashArr = [langDadh, langDadh, dotDash, langDadh];
    } else if (lineMode === 'dash-dot-dot') {
      dashArr = [langDadh, langDadh, dotDash, langDadh, dotDash, langDadh];
    }
    this.setDash(ctx, dashArr);
    ctx.lineWidth = thickness * ratio;
    ctx.strokeStyle = strokeColor;
    ctx.lineCap = 'square';
    ctx.lineJoin = 'round';
    if (fillColor) {
      ctx.fillStyle = fillColor;
    }
  },

  drawPath: function (ctx, pathData, params, ratio) {
    if (_.isUndefined(ratio))
      ratio = 1;
    var thickness = (params.thickness || 1);
    var dashMode = params.dashMode || 'solid';
    var borderColor = params.borderColor || '#000';
    var i = 0;
    var data = pathData.data();
    var l = data.length;
    var p;
    var offset = 0.5 * ratio;
    this.initContextStyle(ctx, thickness, borderColor, undefined, dashMode);

    //ctx.clearRect(0, 0, w, h);
    this.clearRect(ctx);
    ctx.beginPath();
    for (i; i < l; i++) {
      p = data[i];
      if (p.t === 'M') {
        ctx.moveTo(p.x * ratio + offset, p.y * ratio - offset);
        if ((i === l - 1) || (data[i + 1].t === 'M')) {
          ctx.lineTo(p.x * ratio + offset, p.y * ratio - offset);
        }
      } else {
        ctx.lineTo(p.x * ratio + offset, p.y * ratio - offset);
      }
    }
    ctx.stroke();
  },

  drawCurveLine: function (ctx, x1, y1, x2, y2, cx, cy) {
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    if (_.isUndefined(cx) || _.isUndefined(cy)) {
      ctx.lineTo(x2, y2);
    } else {
      ctx.quadraticCurveTo(cx, cy, x2, y2);
    }
    ctx.stroke();
  },

  drawRoundRect: function (ctx, rect, cpx, cpy, params) {
    var strokeStyle = params.strokeStyle;
    var fillStyle = params.color || '#000000';
    var l;
    var t;
    l = rect.left;
    l += cpx;
    t = rect.top;
    ctx.beginPath();
    ctx.moveTo(l, t);
    l = rect.right - cpx;

    ctx.strokeStyle = strokeStyle;
    ctx.fillStyle = fillStyle;
    ctx.lineWidth = params.thickness || 1;
    ctx.lineTo(l, t);
    ctx.quadraticCurveTo(rect.right, rect.top, rect.right, rect.top + cpy);
    ctx.lineTo(rect.right, rect.bottom - cpy);
    ctx.quadraticCurveTo(rect.right, rect.bottom, rect.right - cpx, rect.bottom);
    ctx.lineTo(rect.left + cpx, rect.bottom);
    ctx.quadraticCurveTo(rect.left, rect.bottom, rect.left, rect.bottom - cpx);
    ctx.lineTo(rect.left, rect.top + cpy);
    ctx.quadraticCurveTo(rect.left, rect.top, cpx, rect.top);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
  },

  drawRect: function (ctx, x, y, w, h, params, isFill) {
    ctx.save();
    var thickness = params.thickness || 1;
    var dashMode = params.dashMode || 'solid';
    var borderColor = params.borderColor || '#000';
    var fillColor = params.color || 'transparent';
    var offset = thickness / 2;
    var ratio = this.applyDeviceRatio(ctx, w, h);
    this.clearRect(ctx);

    offset *= ratio;
    this.initContextStyle(ctx, thickness, borderColor, fillColor, dashMode);

    w *= ratio;
    h *= ratio;
    x *= ratio;
    y *= ratio;
    //ctx.clearRect(x, y, w, h);
    if (isFill) {
      ctx.rect(x, y, w, h);
      ctx.fill();
    }
    if (params.borderVisible) {
      ctx.moveTo(x + offset, y + offset);
      ctx.lineTo(w - offset, y + offset);
      // ctx.stroke();
      ctx.moveTo(w - offset, y + offset);
      ctx.lineTo(w - offset, h - offset);
      // ctx.stroke();
      ctx.moveTo(x + offset, h - offset);
      ctx.lineTo(w - offset, h - offset);
      // ctx.stroke();
      ctx.moveTo(x + offset, y + offset);
      ctx.lineTo(x + offset, h - offset);
      ctx.stroke();
    }
    ctx.restore();
  },


  /**
   * 画椭圆形状
   * }}
   */
  drawEllipse: function (context, w, h, color) {
    var EllipseProps = this.figureEllipse(w, h);
    this.clearRect(context);
    context.strokeStyle = color;
    context.save();
    context.scale(EllipseProps["ratioX"], EllipseProps["ratioY"]);
    context.beginPath();
    context.arc(EllipseProps["r"], EllipseProps["r"], EllipseProps["r"] - 0.5, 0, 2 * Math.PI);
    context.stroke();
    context.restore();
  },

  /**
   * 根据角度画椭圆色块
   * }}
   */
  drawEllipseByAngle: function (context, w, h, startAngle, endAngle, color) {

    var EllipseProps = this.figureEllipse(w, h);

    context.fillStyle = color;
    context.save();
    context.scale(EllipseProps["ratioX"], EllipseProps["ratioY"]);
    context.beginPath();
    context.moveTo(EllipseProps["a"] / EllipseProps["ratioX"], EllipseProps["b"] / EllipseProps["ratioY"]);
    context.arc(EllipseProps["r"], EllipseProps["r"], EllipseProps["r"] - 1, startAngle, endAngle, false);
    context.closePath();
    context.restore();
    context.fill();
  },

  figureEllipse: function (w, h) {
    var a = w / 2;
    var b = h / 2;
    var r = (a > b) ? a : b;
    var ratioX = a / r;
    var ratioY = b / r;

    return {"a": a, "b": b, "r": r, "ratioX": ratioX, "ratioY": ratioY};
  },

  //对svg的path进行缩放，以适配动态图标尺寸
  tranSVGStr: function (str, size, max) {
    var ratio = size / max;
    return str.replace(/[0-9]+/g, function (match) {
      var num = parseInt((parseInt(match, 10)) * ratio, 10);
      if (num > size / 2) {
        num = num - 0.5;
      } else {
        num = num + 0.5;
      }
      return num;
    });
  },

  /**
   * svg绘制加减号折叠图标
   * @param size : 图标尺寸
   * @param isClose : 是否收拢状态
   * @param color : 图标颜色
   */
  renderIconPlus: function (size, isClose, color) {
    var path;
    var box = "0 0 " + size.toString() + " " + size.toString();
    if (isClose) {
      path = 'M2.5 2.5 L10.5 2.5 L10.5 10.5 L2.5 10.5 L2.5 2.5 M4.5 6.5 L8.5 6.5 M6.5 4.5 L6.5 8.5';
      return (
        <svg width={size} height={size} style={{float: 'left'}} viewBox={box}>
          <path d={path} strokeWidth="1" stroke={color} fill="none"/>
        </svg>
      );
    }
    else {
      path = 'M2.5 2.5 L10.5 2.5 L10.5 10.5 L2.5 10.5 L2.5 2.5 M4.5 6.5 L8.5 6.5';
      return (
        <svg width={size} height={size} style={{float: 'left'}} viewBox={box}>
          <path d={path} strokeWidth="1" stroke={color} fill="none"/>
        </svg>
      );
    }
  },

  /**
   * svg绘制三角形折叠图标
   * @param size : 图标尺寸
   * @param isClose : 是否收拢状态
   * @param color : 图标颜色
   */
  renderIconArrow: function (size, isClose, color) {
    var path;
    var box = "0 0 " + size.toString() + " " + size.toString()
    if (isClose) {
      path = 'M6 2 L10.5 6.5 L6 11Z';
      return (
        <svg width={size} height={size} style={{float: 'left', left: 2}} viewBox={box}>
          <path d={path} strokeWidth="0" stroke={color} fill="black"/>
        </svg>
      );
    }
    else {
      path = 'M11 4 L11 11 L4 11Z';
      return (
        <svg width={size} height={size} style={{float: 'left'}} viewBox={box}>
          <path d={path} strokeWidth="0" stroke={color} fill="black"/>
        </svg>
      );
    }
  },

  renderCheckIcon: function (size, state) {
    var path;
    var box = "0 0 " + size.toString() + " " + size.toString()
    if (state === 'true') {
      path = 'M0 6 L4 9 L10 1';
      return (
        <svg width={size} height={size} style={{float: 'left', left: 2}} viewBox={box}>
          <path d={path} strokeWidth="1" stroke='black' fill="none"/>
        </svg>
      );
    } else if (state === 'half') {
      path = 'M2 2 L8 2 L8 8 L2 8 Z';
      return (
        <svg width={size} height={size} style={{float: 'left', left: 2}} viewBox={box}>
          <path d={path} strokeWidth="0" stroke='black' fill="black"/>
        </svg>
      );
    }
  },

  /**
   * svg绘制文件夹图标
   * @param size : 图标尺寸
   * @param color : 图标颜色
   */
  renderIconDir: function (size, color) {
    var path = this.tranSVGStr("M 0 208 C 0 208 0 117 125 117 H 350 C 350 117 437 117 437 208 " +
      "V 276 H 890 C 890 276 1024 276 1024 365 V 826 C 1024 826 1024 890 890 890 H 125 " +
      "C 125 890 0 890 0 826 V 208", size, 1024);
    var box = "0 0 " + size.toString() + " " + size.toString();
    return (
      <svg width={size} height={size} style={{float: 'left'}} viewBox={box}>
        <path d={path} strokeWidth="1" stroke={color} fill="none"/>
      </svg>
    )
  },

  /**
   * svg绘制文件图标
   * @param size : 图标尺寸
   * @param color : 图标颜色
   */
  renderIconFile: function (size, color) {
    var path = this.tranSVGStr("M 100 0 L 700 0 L 1000 300 L 1000 1100 L 100 1100 Z M 680 20 L 680 320 L 980 320", size, 1200);
    var box = "0 0 " + size.toString() + " " + size.toString();
    return (
      <svg width={size} height={size} style={{float: 'left'}} viewBox={box}>
        <path d={path} strokeWidth="1" fill="none" vectorEffect="non-scaling-stroke" stroke={color}/>
      </svg>
    )
  },

  /**
   * svg绘制文件图标
   * @param size : 图标尺寸
   * @param color : 图标颜色
   */
  renderEmptyIcon: function (size, color) {
    var path = this.tranSVGStr("M 100 0 L 700 0 L 1000 300 L 1000 1100 L 100 1100 Z M 680 20 L 680 320 L 980 320", size, 1200);
    var box = "0 0 " + size.toString() + " " + size.toString();
    return (
      <svg width={size} height={size} style={{float: 'left'}} viewBox={box}>
        <path d={path} strokeWidth="1" fill="none" vectorEffect="non-scaling-stroke" stroke={color}/>
      </svg>
    )
  },


  tranWordColor: function (str) {

    //var chartColors = this.props.chartColors;//'454445554,4555444444'


    if (str === '白色' || str === '白' || str === 'white' || str === '白' || str === '白色')
      str = '#ffffff';
    if (str === '红色' || str === '红' || str === 'red' || str === '紅' || str === '紅色')
      str = '#ED5555';
    if (str === '绿色' || str === '绿' || str === 'green' || str === '綠' || str === '綠色')
      str = '#A0D468';
    if (str === '蓝色' || str === '蓝' || str === 'blue' || str === '藍' || str === '藍色')
      str = '#5D9CEC';
    if (str === '橙色' || str === '橙' || str === 'orange' || str === '橙' || str === '橙色')
      str = '#FB6E52';
    if (str === '黄色' || str === '黄' || str === 'yellow' || str === '黃' || str === '黃色')
      str = '#FFCE55';
    if (str === '紫色' || str === '紫' || str === 'purple' || str === '紫' || str === '紫色')
      str = '#AC92ED';
    if (str === '银灰色' || str === '银灰' || str === 'silver' || str === '銀灰' || str === '銀灰色')
      str = '#C0C0C0';
    if (str === '粉色' || str === '粉' || str === 'pink' || str === '粉' || str === '粉色')
      str = '#EC87BF';
    if (str === '青色' || str === '青' || str === 'cyan' || str === '青' || str === '青色')
      str = '#48CFAE';
    if (str === '浅灰色' || str === '浅灰' || str === 'lightgrey' || str === '淺灰' || str === '淺灰色')
      str = '#E6E6E6';
    if (str === '灰色' || str === '灰' || str === 'grey' || str === '灰' || str === '灰色')
      str = '#808080';
    if (str === '深灰色' || str === '深灰' || str === 'darkgrey' || str === '深灰色' || str === '深灰')
      str = '#999999';
    if (str === '兰色' || str === '兰' || str === '蘭' || str === 'blue' || str === '蘭色')
      str = '#5D9CEC';
    return str;
  },

  tranSimpleColor: function (str) {
    var re0 = new RegExp("^#([0-9a-fA-F]{6})$");
    var re1 = new RegExp("^#([0-9a-fA-F]{3})$");
    var re2 = new RegExp("^[#|\$]([0-9a-fA-F]{1})$");
    var re3 = new RegExp("^[#|\$]([0-9a-fA-F]{8,})$");
    var re4 = new RegExp("^([0-9a-fA-F]{6})$");
    var re5 = new RegExp("^([0-9a-fA-F]{3})$");
    var re6 = new RegExp("^([0-9a-fA-F]{1})$");
    var re7 = new RegExp("^([0-9a-fA-F]{8,})$");

    if (re0.test(str)) {     //6位颜色值
      str = "ff" + str.substring(1, 7);
    }
    else if (re1.test(str)) {     //3位颜色值
      str = "ff" + str.substring(1, 2).repeat(2) +
        str.substring(2, 3).repeat(2) + str.substring(3, 4).repeat(2);
    }
    /*else if(re2.test(str)) {     //1位颜色值
      str = "ff" + str.substring(1,2).repeat(6);
    }
    else if(re3.test(str)) {     //8位以上颜色值
      str = str.substring(1,9);
    }
    else if(re4.test(str)) {     //6位颜色值
      str = "ff" + str;
    }
    else if(re5.test(str)) {     //3位颜色值
      str = "ff" + str.substring(0,1).repeat(2) +
        str.substring(1,2).repeat(2) + str.substring(2,3).repeat(2);
    }
    else if(re6.test(str)) {     //1位颜色值
      str = "ff" + str.substring(0,1).repeat(6);
    }
    else if(re7.test(str)) {     //8位以上颜色值
      str = str.substring(0,8);
    }*/
    else {
      str = "empty";
    }
    return str;
  },

  tranColor: function (str) {
    if(str) {
      str = str.toLowerCase();
    }
    //将单词形式的颜色转换
    str = this.tranWordColor(str);
    //将简写颜色值转换为标准值
    str = this.tranSimpleColor(str);
    return str;
  },

  tranIndex: function (i, length) {
    if (length <= 0) {     //长度必须为负数，防御除零错误
      return null;
    }
    i = i % length;
    if (i < 0) {
      i = length + i;
    }
    return i;
  },

  getTempleteColor: function (colors) {

    var index = -1;

    for (var i = 0; i < colors.length; i++) {
      if (colors[i] === "empty") {    //脏数据
        var pre = colors[this.tranIndex(i - 1, colors.length)].toLowerCase();
        var next = colors[this.tranIndex(i + 1, colors.length)].toLowerCase();
        while (true) {     //无限循环，找模板中不与前后相同的颜色，理论上最多比较两种颜色
          index = this.tranIndex(index + 1, colorTemplete.length);
          if (colorTemplete[index] != pre
            && colorTemplete[index] != next) {
            colors[i] = colorTemplete[index];       //修改颜色
            break;
          }
        }
      }
    }
  },

  tranData: function (str, maxValue) {
    var f = parseFloat(str);
    if (isNaN(f)) {
      f = 0;
    }
    //if (f < Math.pow(10, str.length - 1)) {      //判断是否所有字符都可装换为数字
    //  f = 0;
    //}
    if (maxValue && f > maxValue) {
      f = maxValue;
    }
    return f;
  },

  tranToRGBA: function (colors) {
    for (var i = 0; i < colors.length; i++) {

      colors[i] = this.toRGBA(colors[i]);
    }
  },

  toRGBA: function (colorStr) {
    colorStr = colorStr.toLowerCase();
    var a = (parseInt(colorStr.substring(0, 2), 16) / 255).toString();
    var r = parseInt(colorStr.substring(2, 4), 16).toString();
    var g = parseInt(colorStr.substring(4, 6), 16).toString();
    var b = parseInt(colorStr.substring(6, 8), 16).toString();

    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
  },

  /**
   * 解析图标文本，转换为数据和颜色
   * }}
   */
  parseText: function (text, maxValue) {

    //1、以换行划分文本，取出各区域
    var lines = text.split(/\s+/);
    var areas = new Array();
    var colors = new Array();

    for (var i = 0; i < lines.length; i++) {

      //2、中文逗号转英文，以英文逗号划分比例和颜色
      var areaAndColors = lines[i].replace("，", ",").split(",");

      //3、按策略转化数组第一个元素为数字
      var area = this.tranData(areaAndColors[0], maxValue);
      if (area === 0) {
        continue;
      }
      areas.push(area);

      //5、按策略转化数组第二个元素为标准颜色值
      var color = this.tranColor(areaAndColors[1]);
      colors.push(color);

    }

    //5、遍历colors，找出脏数据，替换成模板颜色
    this.getTempleteColor(colors);
    //将颜色转化为rgba格式
    this.tranToRGBA(colors);

    return {"areas": areas, "colors": colors};
  },


  /**
   * 绘制形状
   * @param graphics
   * @param props :{
     * {
     *  width : number,
     *  height : number,
     *  borderType:String，
     *  triangleType，
     *  [borderVisible:boolean,]
     *  [borderColor : string,]
     *  [fillColor : string,]
     *  [radius:number,]
     *  [borderWidth:number,]
     *  [borderLeft:boolean,]
     *  [borderRight:boolean,]
     *  [borderTop:boolean,]
     *  [borderBottom:boolean,]
     *  [image:document]
     * }}
   */
  drawShpae: function (graphics, props) {
    var width = props.width;
    var height = props.height;
    var borderType = props.borderType;
    var borderVisible = props.borderVisible || false;
    var borderColor = props.borderColor || '#000';
    var fillColor = props.fillColor || '#fff';
    var radius = props.radius;
    var borderWidth = props.borderWidth || 1;
    var triangleType = props.triangleType;
    var img = props.image;
    var left = 0;
    var top = 0;

    if (!borderVisible) {
      borderWidth = 0;
    }
    var ratio = 1;
    var rect = {};
    util.Rect.setLocation(rect, left, top);
    util.Rect.setSize(rect, width, height);
    ratio = this.applyDeviceRatio(graphics, width, height);
    this.clearRect(graphics);
    //graphics.clearRect(0, 0, width, height);
    graphics.save();
    if (img) {
      if (borderType !== appTypes.ShapeType.RECTANGLE) {
        graphics.rect(rect.left * ratio, rect.top * ratio, rect.width * ratio, rect.height * ratio);
      }
    }

    this.initContextStyle(graphics, borderWidth, borderColor, fillColor, props.dashMode);

    createPath(graphics, rect, radius, borderType, triangleType, ratio);
    if (img) {
      graphics.drawNineGridImage(img, left, top, width, height);
      graphics.fill();
    } else {
      graphics.fill();
    }

    util.Rect.shrink(rect, borderWidth / 2, borderWidth / 2);
    if (borderType === appTypes.ShapeType.RECTANGLE) {
      roundRect(graphics, 1, 1, rect.width + borderWidth - 1, rect.height + borderWidth - 1, radius, true, false, {
        left: props.borderLeft,
        top: props.borderTop,
        right: props.borderRight,
        bottom: props.borderBottom
      }); // 画矩形
    }
    if (borderVisible) {
      if (borderType === appTypes.ShapeType.RECTANGLE) {
        roundRect(graphics, borderWidth / 2, borderWidth / 2, rect.width, rect.height, radius, false, true, {
          left: props.borderLeft,
          top: props.borderTop,
          right: props.borderRight,
          bottom: props.borderBottom
        });
      } else {
        createPath(graphics, rect, radius, borderType, triangleType, 1);
        graphics.stroke();
      }
    }
  },

  drawTriangle: function (graphics, props) {
    var width = props.width;
    var height = props.height;
    var borderVisible = props.borderVisible || false;
    var borderColor = props.borderColor || '#000';
    var fillColor = props.fillColor || '#fff';
    var borderWidth = props.borderWidth || 1;
    var triangleType = props.triangleType;
    var triangleDirection = props.triangleDirection;
    var left = 0;
    var top = 0;

    if (!borderVisible) {
      borderWidth = 0;
    }

    var rect = {};
    util.Rect.setLocation(rect, left, top);
    util.Rect.setSize(rect, width, height);
    graphics.clearRect(0, 0, width, height);
    graphics.save();

    this.initContextStyle(graphics, borderWidth, borderColor, fillColor, props.dashMode);

    createTrianglePath(graphics, rect, triangleType, triangleDirection);

    graphics.fill();


    util.Rect.shrink(rect, borderWidth / 2, borderWidth / 2);

    if (borderVisible) {
      createTrianglePath(graphics, rect, triangleType, triangleDirection);
      graphics.stroke();
    }
  },

  drawLine: function (ctx, props) {
    var lineWidth = props.lineWidth || 1;
    var strokeColor = props.strokeColor || '#000';
    var dashMode = props.dashMode || 'solid';

    this.initContextStyle(ctx, lineWidth, strokeColor, null, dashMode);
    ctx.beginPath();

    ctx.moveTo(props.startX, props.startY);
    ctx.lineTo(props.endX, props.endY);
    ctx.stroke();
  },

  //绘制矩形内的分割线
  drawDivision: function (ctx, params) {

    var thickness = params.thickness || 1;
    var dashMode = params.dashMode || 'solid';
    var lineColor = params.lineColor || '#000';
    var margin = params.margin || 0;
    var w = params.width;
    var h = params.height;
    var itemWidth = params.itemWidth;
    var itemHeight = params.itemHeight;
    var horiGap = params.horiGap || 10;
    var vertGap = params.vertGap || 10;
    var col = parseInt(w / itemWidth, 10);
    var row = parseInt(h / itemHeight, 10);
    var i;

    this.initContextStyle(ctx, thickness, lineColor, null, dashMode);

    ctx.clearRect(0, 0, w, h);
    if (params.showSeparator) {

      for (i = 0; i < col; i++) {
        var baseX = parseInt(itemWidth + horiGap / 2, 10);
        var offsetX = parseInt(itemWidth + horiGap, 10);
        var drawX = baseX + offsetX * i + (thickness % 2 === 0 ? 0 : 0.5);
        ctx.moveTo(drawX, margin);
        ctx.lineTo(drawX, h - margin);
        ctx.stroke();
      }

      for (i = 0; i < row; i++) {
        var baseY = parseInt(itemHeight + vertGap / 2, 10);
        var offsetY = parseInt(itemHeight + vertGap, 10);
        var drawY = baseY + offsetY * i + (thickness % 2 === 0 ? 0 : 0.5);
        ctx.moveTo(margin, drawY);
        ctx.lineTo(w - margin, drawY);
        ctx.stroke();
      }
    }
  },

  /*
   * 圆角矩形绘制
   * */
  // rectRadius: function(graphics, rect, radius, borderLeft, borderTop, borderRight, borderBottom){
  //     if (borderLeft) {
  //         graphics.rect(rect.left, rect.top, rect.width, rect.height);
  //         console.log('borderLeft');
  //     }
  //     if (borderTop) {
  //         console.log('borderTop');
  //     }
  //     if (borderRight) {
  //         console.log('borderRight');
  //     }
  //     if (borderBottom) {
  //         console.log('borderBottom');
  //     }
  //     if (borderLeft && borderTop && borderRight && borderBottom) {
  //
  //     }
  // },


  /***
   * 九宫格绘图，4 个参数缺一不可
   * @author mengxiaojiang
   * @createDate 2016-7-4
   * @param graphics canvas.getContext('2d')
   * @param img  img Document
   * @param sourceRect9 图片的九宫格裁切区域，格式｛left:number,top:number,right:number,bottom:number｝
   * @param destRect 绘制的目标区域,格式｛left:number,top:number,right:number,bottom:number｝
   */
  drawNineGridImage: function (graphics, img, sourceRect9, destRect) {
    var imgW;
    var imgH;
    var sx;
    var sy;
    var sw;
    var sh;
    var dx;
    var dy;
    var dw;
    var dh;
    var ratio = 1;
    var r;
    if (!graphics || !img || !sourceRect9 || !destRect) {
      return;
    }

    imgW = img.naturalWidth;
    imgH = img.naturalHeight;
    //左上
    sx = 0;
    sy = 0;
    sw = sourceRect9.left;
    sh = sourceRect9.top;
    dx = sx;
    dy = sy;
    dw = sw;
    dh = sh;
    ratio = this.applyDeviceRatio(graphics, destRect.right, destRect.bottom);
    this.clearRect(graphics);

    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
    //return;
    //graphics.clearRect(destRect.left, destRect.top, destRect.right, destRect.bottom);
    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    //顶上
    sx = sourceRect9.left;
    sw = sourceRect9.right - sx;
    dx = sx;
    dw = destRect.right - (imgW - sw);
    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);

    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
    //右上
    sx = sourceRect9.right;
    sw = imgW - sx;
    dx = destRect.right - sw;
    dw = sw;
    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
    //左
    sx = 0;
    sy = sourceRect9.top;
    sw = sourceRect9.left;
    sh = sourceRect9.bottom - sy;
    dx = sx;
    dy = sy;
    dw = sw;
    dh = destRect.bottom - (imgH - sh);
    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
    //中
    sx = sourceRect9.left;
    sw = sourceRect9.right - sx;
    dx = sx;
    dw = destRect.right - (imgW - sw);
    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
    //右
    sx = sourceRect9.right;
    sw = imgW - sx;
    dx = destRect.right - sw;
    dw = sw;
    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
    //左下
    sx = 0;
    sy = sourceRect9.bottom;
    sw = sourceRect9.left;
    sh = imgH - sy;
    dx = sx;
    dw = sw;
    dh = sh;
    dy = destRect.bottom - dh;
    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
    //底
    sx = sourceRect9.left;
    sw = sourceRect9.right - sx;
    dx = sx;
    dw = destRect.right - destRect.left;
    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
    //右下
    sx = sourceRect9.right;
    sw = imgW - sx;
    dx = destRect.right - sw;
    dw = sw;
    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
  },

  /**
   * 水平三段绘制图片
   * @author mengxiaojiang
   * @createDate 2016-7-4
   * @param graphics
   * @param img
   * @param left
   * @param right
   * @param destRect
   */
  drawHorizontalThreeGridImage: function (graphics, img, left, right, destRect) {
    var sx;
    var sy;
    var sw;
    var sh;
    var dx;
    var dy;
    var dw;
    var dh;
    var imgH = img.naturalHeight;
    var imgW = img.naturalWidth;
    var ratio = 1;
    util.Rect.init(destRect);

    sx = 0;
    sy = 0;
    sw = left;
    sh = imgH;
    dx = destRect.left;
    dy = destRect.top;
    dw = sw;
    dh = destRect.height;// destRect.bottom - dy;

    ratio = this.applyDeviceRatio(graphics, destRect.width, destRect.height);

    this.clearRect(graphics);
    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    if (right !== left) {
      sx = left;
      sw = right - left;
      dx = destRect.left + sx;
      dw = destRect.right - destRect.left - (imgW - sw);
      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
      sx = right;
      sw = imgW - sx;
      dx = destRect.right - sw;
      dw = sw;
      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
    } else {
      sx = left;
      sw = imgW - sx;
      dx = destRect.left + sx;
      dw = destRect.right - left;
      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
    }
  },

  /**
   * 垂直三段绘制图片
   * @author mengxiaojiang
   * @createDate 2016-7-4
   * @param graphics
   * @param img
   * @param top
   * @param bottom
   * @param destRect
   */
  drawVerticalThreeGridImage: function (graphics, img, top, bottom, destRect) {
    var sx;
    var sy;
    var sw;
    var sh;
    var dx;
    var dy;
    var dw;
    var dh;
    var imgH = img.naturalHeight;
    var imgW = img.naturalWidth;
    var ratio = 1;
    sx = 0;
    sy = 0;
    sw = imgW;
    sh = top;
    dx = destRect.left;
    dy = destRect.top;
    dw = destRect.right - destRect.left;
    dh = sh;
    //graphics.clearRect(0, 0, dw, dh);
    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    ratio = this.applyDeviceRatio(graphics, dw, dh);
    this.clearRect(graphics);
    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh));
    if (bottom !== top) {
      sy = top;
      sh = bottom - top;
      dy = sy;
      dh = destRect.bottom - destRect.top - (imgH - sh);
      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh));
      sy = bottom;
      sh = imgH - sy;
      dy = destRect.bottom - sh;
      dh = sh;
      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh));
    } else {
      sy = top;
      sh = imgH - sy;
      dy = destRect.top + sy;
      dh = destRect.bottom - top;
      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh));
    }
  },

  /**
   * 绘制图片，此过程是一个比较耗时的过程，不建议在渲染的过程频繁的绘制
   * @author mengxiaojiang
   * @createDate 2016-7-4
   * @param graphics
   * @param img
   * @param color {'#FFF'|#FFFFFF'|'rgba(r,g,b,a)'|null}，如果不为null，则会替换图片的颜色
   * @param sourceRect {{left:(number),right:(number)}|{top:(number),bottom:(number)}|{left:(number),top:(number),right:(number),bottom:(number)}|null}，图片的九宫格拉伸区域
   * @param destRect {{left:(number),top:(number),right:(number),bottom:(number)}|null} ，图片绘制的目标区域
   */
  drawColorImage: function (graphics, img, color, sourceRect, destRect) {
    var w = img.naturalWidth;
    var h = img.naturalHeight;
    var dw;
    var dh;
    //var sw;
    //var sh;
    //var imgData;
    //var rgb;
    var type = 0;
    var sr = {
      left: 0,
      top: 0,
      right: w,
      bottom: h
    };
    var dr = {
      left: 0,
      top: 0,
      right: w,
      bottom: h
    };
    var self = this;
    this.getImageSize(img, function (err, size, img) {
      if (err) {
        console.error(err);
        return;
      }
      var imgW = size.width;
      var imgH = size.height;
      var ratio = 1;
      if (!imgW || !imgH) {
        return;
      }
      if (sourceRect) {
        if (!_.isUndefined(sourceRect.left) && !_.isUndefined(sourceRect.right) && !_.isUndefined(sourceRect.top) && !_.isUndefined(sourceRect.bottom)) {
          type = 1;
        } else if (!_.isUndefined(sourceRect.left) && !_.isUndefined(sourceRect.right)) {
          type = 2;
        } else if (!_.isUndefined(sourceRect.top) && !_.isUndefined(sourceRect.bottom)) {
          type = 3;
        }
        if (!_.isUndefined(sourceRect.left)) {
          sr.left = sourceRect.left;
        }
        if (!_.isUndefined(sourceRect.top)) {
          sr.top = sourceRect.top;
        }
        if (!_.isUndefined(sourceRect.right)) {
          sr.right = sourceRect.right;
        }
        if (!_.isUndefined(sourceRect.bottom)) {
          sr.bottom = sourceRect.bottom;
        }
      }

      if (destRect) {
        if (!_.isUndefined(destRect.left)) {
          dr.left = destRect.left;
        }
        if (!_.isUndefined(destRect.top)) {
          dr.top = destRect.top;
        }
        if (!_.isUndefined(destRect.right)) {
          dr.right = destRect.right;
        }
        if (!_.isUndefined(destRect.bottom)) {
          dr.bottom = destRect.bottom;
        }
      }
      if (destRect) {
        dw = destRect.right - destRect.left;
        dh = destRect.bottom - destRect.top;
      } else {
        dw = imgW;
        dh = imgH;
      }

      //if(sourceRect){
      //  sw = sourceRect.right - sourceRect.left;
      //  sh = sourceRect.bottom  - sourceRect.top;
      //}else{
      //  sw = destRect.right - destRect.left;
      //  sh = destRect.bottom - destRect.top;
      //}
      //graphics.clearRect(0, 0, dw, dh);
      ratio = self.applyDeviceRatio(graphics, dw, dh);
      self.clearRect(graphics);
      graphics.globalCompositeOperation = 'source-over';
      if (type === 0) {
        self.drawImage(graphics, img, util.Rect.create(0, 0, imgW, imgH), util.Rect.create(0, 0, dw, dh), ratio);
      } else if (type === 1) {
        self.drawNineGridImage(graphics, img, sr, dr);
      } else if (type === 2) {
        self.drawHorizontalThreeGridImage(graphics, img, sr.left, sr.right, dr);
      } else if (type === 3) {
        self.drawVerticalThreeGridImage(graphics, img, sr.top, sr.bottom, dr);
      } else {
        return;
      }
      if (color) {
        //imgData = graphics.getImageData(0,0,dw,dh);
        //replacecolor(imgData.data,color);
        //graphics.putImageData(imgData,0,0);
        graphics.globalCompositeOperation = 'source-in';
        createPath(graphics, {left: 0, top: 0, right: dw, bottom: dh}, 0, null, null, ratio);
        graphics.fillStyle = color;
        graphics.fill();
      }
    });
  },

  applyDeviceRatio: function (graphics, width, height) {
    var ratio = this.getDeviceRatio(graphics);
    graphics.canvas.width = width * ratio;
    graphics.canvas.height = height * ratio;
    return ratio;
  },

  getDeviceRatio: function (graphics) {
    var dratio = window.devicePixelRatio || 1;
    var gratio = graphics.backingStorePixelRatio ||
      graphics.webkitBackingStorePixelRatio ||
      graphics.mozBackingStorePixelRatio ||
      graphics.msBackingStorePixelRatio ||
      graphics.oBackingStorePixelRatio ||
      graphics.backingStorePixelRatio || 1;
    return dratio / gratio;
  },

  clearRect: function (graphics, rect) {
    if (_.isUndefined(rect)) {
      rect = util.Rect.create(0, 0, graphics.canvas.width, graphics.canvas.height);
    }
    graphics.clearRect(rect.left, rect.top, rect.width, rect.height);
  },
  drawImage: function (graphics, img, srcRect, desRect, ratio) {

    var srcX = srcRect.left;
    var srcY = srcRect.top;
    var srcW = srcRect.width;
    var srcH = srcRect.height;
    var desX = desRect.left;
    var desY = desRect.top;
    var desW = desRect.width;
    var desH = desRect.height;
    if (_.isUndefined(ratio)) {
      ratio = 1;
    }
    //var ratio = this.applyDeviceRatio(graphics,desW,desH);
    graphics.drawImage(img, srcX, srcY, srcW, srcH, desX * ratio, desY * ratio, desW * ratio, desH * ratio);
  },

  drawFilterImage: function (graphics, img, destRect, fitMode, filterProps, shapeProps, faildcall) {
    //var imgData;
    //var pixes;
    var width = img.width;
    var height = img.height;
    var imgW = img.naturalWidth || img.width;
    var imgH = img.naturalHeight || img.height;

    var isRepeat = appTypes.ImageFitMode.TILE.indexOf(fitMode) !== -1;
    var isFilled = appTypes.ImageFitMode.Fill.indexOf(fitMode) !== -1;
    var isFit = appTypes.ImageFitMode.Fit.indexOf(fitMode) !== -1;
    var isCenter = appTypes.ImageFitMode.CENTER.indexOf(fitMode) !== -1;
    var dRect;

    //var copyPixes;
    //var filterType = filterProps.filterType;
    //var filterValue = filterProps.filterValue;
    //var drawBorder = false;
    var shapeType;
    var radius;
    //var triangleType;
    var rect;
    //var borderWidth;
    var pat;
    //var ratio = 1;
    if (destRect) {
      width = destRect.right - destRect.left;
      height = destRect.bottom - destRect.top;
    }

    rect = {
      left: 0,
      top: 0,
      right: width,
      bottom: height
    };

    //if (!filterValue) {
    //  filterValue = 3;
    //} else {
    //  filterValue = filterValue;
    //}
    if (shapeProps) {
      shapeType = shapeProps.shapeType;
      radius = shapeProps.radius;
      //drawBorder = shapeProps.borderVisible;
      //triangleType = shapeProps.triangleType;
      //borderWidth = shapeProps.borderWidth;
      //if (!borderWidth) {
      //  borderWidth = 1;
      //}
    }

    //ratio = graphics.backingStorePixelRatio ||
    //  graphics.webkitBackingStorePixelRatio ||
    //  graphics.mozBackingStorePixelRatio ||
    //  graphics.msBackingStorePixelRatio ||
    //  graphics.oBackingStorePixelRatio ||
    //  graphics.backingStorePixelRatio || 1;
    //
    //ratio = (window.devicePixelRatio || 1)/ratio;
    /*
     "copy"	只绘制新图形，删除其他所有内容。
     "darker"	在图形重叠的地方，颜色由两个颜色值相减后决定。
     "destination-atop"	已有的内容只有在它和新的图形重叠的地方保留。新图形绘制于内容之后。
     "destination-in"	在新图形以及已有画布重叠的地方，已有内容都保留。所有其他内容成为透明的。
     "destination-out"	在已有内容和新图形不重叠的地方，已有内容保留。所有其他内容成为透明。
     "destination-over"	新图形绘制于已有内容的后面。
     "lighter"	在图形重叠的地方，颜色由两种颜色值的加值来决定。
     "source-atop"	只有在新图形和已有内容重叠的地方，才绘制新图形。
     "source-in"	在新图形以及已有内容重叠的地方，新图形才绘制。所有其他内容成为透明。
     "source-out"	只有在和已有图形不重叠的地方，才绘制新图形。
     "source-over"	新图形绘制于已有图形的顶部。这是默认的行为。
     "xor"
     */

    //加入密度的计算
    //graphics.canvas.width = width * ratio;
    //graphics.canvas.height = height * ratio;
    graphics.globalCompositeOperation = 'copy';
    if (imgW > MAX_IMGSIZE || imgH > MAX_IMGSIZE) {
      if (faildcall) { //超大图片直接不绘制
        faildcall();
      }
      return;
    }
    if (!isRepeat) {
      //graphics.drawImage(img, 0, 0, imgW , imgH , 0, 0, width * ratio, height * ratio);
      var ratio = this.applyDeviceRatio(graphics, width, height);
      var srcRect = util.Rect.create(0, 0, imgW, imgH);
      dRect = util.Rect.create(0, 0, rect.right-rect.left, rect.bottom-rect.top);
      //填充模式为填充时，图片等比例充满组件区域
      if (isFilled) {
        if (imgW / imgH > width / height) {
          srcRect = util.Rect.create((imgW - imgH * width / height) / 2, 0, imgH * width / height, imgH);
        } else if (imgH / imgW > height / width) {
          srcRect = util.Rect.create(0, (imgH - imgW * height / width) / 2, imgW, imgW * height / width);
        }
      }
      //当填充模式选项为适应时，图片等比例缩放来适应组件宽高
      if (isFit) {
        if (imgW / imgH > width / height) {
          dRect = util.Rect.create(0, (height - width * imgH / imgW) / 2, width, width * imgH / imgW);
        } else if (imgH / imgW > height / width) {
          dRect = util.Rect.create((width - height * imgW  / imgH) / 2, 0, height * imgW  / imgH, height);
        }
      }
      //当填充模式选项为居中时，图片宽高不变，居中显示
      if (isCenter) {
        var x = imgW<width?0:(imgW-width)/2;
        var y = imgH<height?0:(imgH-height)/2;
        var w = Math.min(imgW, width);
        var h = Math.min(imgH, height);
        srcRect = util.Rect.create(x, y, w, h);
        x = imgW<width?(width-imgW)/2:0;
        y = imgH<height?(height-imgH)/2:0;
        dRect = util.Rect.create(x, y, w, h);
      }

      this.drawImage(graphics, img, srcRect, dRect, ratio);
    } else {
      pat = graphics.createPattern(img, 'repeat');
      graphics.fillStyle = pat;
      graphics.rect(0, 0, width, height);
      graphics.fill();
    }
    //获取原图数据

    if (shapeType) {
      if (radius) {
        radius = parseInt(radius, 10);
      }
      if (shapeType !== appTypes.ShapeType.RECTANGLE || radius) {
        graphics.globalCompositeOperation = 'destination-in';
        graphics.fillStyle = 'rgba(255,255,255,1)';
        createPath(graphics, rect, radius, shapeType, null, ratio);
        graphics.fill();

      }
    }
  }
};

/**
 * 根据需要绘制的形状，生成一个路径区域，该函数不负责区域的填充
 * @param graphics
 * @param rect ｛left:number,top:number,right:number,bottom:number｝
 * @param radius number
 * @param borderType string
 * @param triangleType string
 */
function createPath(graphics, rect, radius, borderType, triangleType, ratio) {
  if (_.isUndefined(ratio)) {
    ratio = 1;
  }
  if (rect) {
    //rect.width = rect.right - rect.left;
    //rect.height = rect.bottom - rect.top;
    //rect.center = {
    //  x: rect.left + rect.width / 2,
    //  y: rect.top + rect.height / 2
    //};
    util.Rect.scale(rect, ratio, true);
    util.Rect.init(rect);
  }

  if (!borderType) {
    borderType = appTypes.ShapeType.RECTANGLE;
  }
  graphics.beginPath();
  if (borderType === appTypes.ShapeType.RECTANGLE) {
    if (radius) {

      graphics.moveTo(rect.left + radius, rect.top);
      graphics.lineTo(rect.right - radius, rect.top);

      //graphics.arcTo(rect.right-radius,rect.top,rect.right,rect.top + radius,radius);
      graphics.arc(rect.right - radius, rect.top + radius, radius, 0, 90);

      graphics.quadraticCurveTo(rect.right, rect.top, rect.right, rect.top + radius);
      graphics.lineTo(rect.right, rect.bottom - radius);
      graphics.quadraticCurveTo(rect.right, rect.bottom, rect.right - radius, rect.bottom);
      graphics.lineTo(rect.left + radius, rect.bottom);
      graphics.quadraticCurveTo(rect.left, rect.bottom, rect.left, rect.bottom - radius);
      graphics.lineTo(rect.left, rect.top + radius);
      graphics.quadraticCurveTo(rect.left, rect.top, rect.left + radius, rect.top);
    } else {
      graphics.rect(rect.left, rect.top, rect.width, rect.height);
    }
  }
  //椭圆
  else if (borderType === appTypes.ShapeType.ELLIPSE) {
    graphics.moveTo(rect.left, rect.center.y);
    graphics.bezierCurveTo(rect.left, rect.top + rect.height * 0.22662, rect.left + rect.width * 0.22662, rect.top, rect.center.x, rect.top);
    graphics.bezierCurveTo(rect.left + rect.width * 0.77338, rect.top, rect.right, rect.top + rect.height * 0.22662, rect.right, rect.center.y);
    graphics.bezierCurveTo(rect.right, rect.top + rect.height * 0.77338, rect.left + rect.width * 0.77338, rect.bottom, rect.center.x, rect.bottom);
    graphics.bezierCurveTo(rect.left + rect.width * 0.22662, rect.bottom, rect.left, rect.top + rect.height * 0.77338, rect.left, rect.center.y);
  }
  //菱形
  else if (borderType === appTypes.ShapeType.DIAMOND) {
    graphics.moveTo(rect.center.x, rect.top);
    graphics.lineTo(rect.right, rect.center.y);
    graphics.lineTo(rect.center.x, rect.bottom);
    graphics.lineTo(rect.left, rect.center.y);
  }
  // 平行四边形
  else if (borderType === appTypes.ShapeType.PARALLELOGRAM) {
    graphics.moveTo(rect.left + rect.width * 0.2, rect.top);
    graphics.lineTo(rect.right, rect.top);
    graphics.lineTo(rect.left + rect.width * 0.8, rect.bottom);
    graphics.lineTo(rect.left, rect.bottom);
  }
  //三角形
  else if (borderType === appTypes.ShapeType.TRIANGLE) {
    if (triangleType === appTypes.RotationAngle.TWO_HUNDRED_SEVENTY) {
      graphics.moveTo(rect.right, rect.top);
      graphics.lineTo(rect.right, rect.bottom);
      graphics.lineTo(rect.left, rect.center.y);
      graphics.lineTo(rect.right, rect.top);

    } else if (triangleType === appTypes.RotationAngle.NINETY) {
      graphics.moveTo(rect.left, rect.top);
      graphics.lineTo(rect.right, rect.center.y);
      graphics.lineTo(rect.left, rect.bottom);
      graphics.lineTo(rect.left, rect.top);
    } else if (triangleType === appTypes.RotationAngle.ONE_HUNDRED_EIGHTY) {
      graphics.moveTo(rect.left, rect.top);
      graphics.lineTo(rect.right, rect.top);
      graphics.lineTo(rect.center.x, rect.bottom);
      graphics.lineTo(rect.left, rect.top);
    } else {
      graphics.moveTo(rect.center.x, rect.top);
      graphics.lineTo(rect.right, rect.bottom);
      graphics.lineTo(rect.left, rect.bottom);
      graphics.lineTo(rect.center.x, rect.top);
    }
  }
  //五角星
  else if (borderType === appTypes.ShapeType.STAR) {
    graphics.moveTo(rect.left + rect.width * 0.5, rect.top);
    graphics.lineTo(rect.left + rect.width * 0.66, rect.top + rect.height * 0.33);
    graphics.lineTo(rect.left + rect.width, rect.top + rect.height * 0.38);
    graphics.lineTo(rect.left + rect.width * 0.75, rect.top + rect.height * 0.63);
    graphics.lineTo(rect.left + rect.width * 0.8, rect.bottom);

    graphics.lineTo(rect.left + rect.width * 0.5, rect.top + rect.height * 0.83);
    graphics.lineTo(rect.left + rect.width * 0.2, rect.bottom);
    graphics.lineTo(rect.left + rect.width * 0.25, rect.top + rect.height * 0.63);
    graphics.lineTo(rect.left, rect.top + rect.height * 0.36);
    graphics.lineTo(rect.left + rect.width * 0.34, rect.top + rect.height * 0.33);

    graphics.lineTo(rect.left + rect.width * 0.5, rect.top);
  }

  graphics.closePath();
}

function createTrianglePath(graphics, rect, triangleType, triangleDirection) {
  if (rect) {
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.center = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2
    };
  }

  graphics.beginPath();

  if (triangleType === 'ttRightAngle') {     //等边三角形，绘制路径不一样
    if (triangleDirection === appTypes.RotationAngle.TWO_HUNDRED_SEVENTY) {
      graphics.moveTo(rect.left, rect.top);
      graphics.lineTo(rect.right, rect.top);
      graphics.lineTo(rect.left, rect.bottom);
      graphics.lineTo(rect.left, rect.top);

    } else if (triangleDirection === appTypes.RotationAngle.NINETY) {
      graphics.moveTo(rect.right, rect.top);
      graphics.lineTo(rect.right, rect.bottom);
      graphics.lineTo(rect.left, rect.bottom);
      graphics.lineTo(rect.right, rect.top);
    } else if (triangleDirection === appTypes.RotationAngle.ONE_HUNDRED_EIGHTY) {
      graphics.moveTo(rect.left, rect.top);
      graphics.lineTo(rect.right, rect.top);
      graphics.lineTo(rect.right, rect.bottom);
      graphics.lineTo(rect.left, rect.top);
    } else {
      graphics.moveTo(rect.left, rect.top);
      graphics.lineTo(rect.right, rect.bottom);
      graphics.lineTo(rect.left, rect.bottom);
      graphics.lineTo(rect.left, rect.top);
    }
  } else {
    if (triangleDirection === appTypes.RotationAngle.TWO_HUNDRED_SEVENTY) {
      graphics.moveTo(rect.right, rect.top);
      graphics.lineTo(rect.right, rect.bottom);
      graphics.lineTo(rect.left, rect.center.y);
      graphics.lineTo(rect.right, rect.top);

    } else if (triangleDirection === appTypes.RotationAngle.NINETY) {
      graphics.moveTo(rect.left, rect.top);
      graphics.lineTo(rect.right, rect.center.y);
      graphics.lineTo(rect.left, rect.bottom);
      graphics.lineTo(rect.left, rect.top);
    } else if (triangleDirection === appTypes.RotationAngle.ONE_HUNDRED_EIGHTY) {
      graphics.moveTo(rect.left, rect.top);
      graphics.lineTo(rect.right, rect.top);
      graphics.lineTo(rect.center.x, rect.bottom);
      graphics.lineTo(rect.left, rect.top);
    } else {
      graphics.moveTo(rect.center.x, rect.top);
      graphics.lineTo(rect.right, rect.bottom);
      graphics.lineTo(rect.left, rect.bottom);
      graphics.lineTo(rect.center.x, rect.top);
    }
  }
  graphics.closePath();
}


// WEBPACK FOOTER //
// ./src/helper/graphicsHelper.js